<template>
    <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4 contenedor-principal">
        <busqueda-contacto-lead v-if="mostrarBusquedaContactoLead" />
        <template v-if="esInmobiliario">
          <cliente-inmobiliario-grid/>
        </template>
        <template v-else>
          <clientes-grid/>
        </template>
    </div>
</template>

<script setup lang="ts">
import ClientesGrid from "@/components/clientes/ClientesGrid.vue";
import ClienteInmobiliarioGrid from '@/components/clientes-inmobiliarios/ClienteInmobiliarioGrid.vue';
import BusquedaContactoLead from "@/components/clientes/BusquedaContactoLead.vue";
import { TipoEmpresaServiciosEnum } from "@api/api";
import { useApi } from "@api/integration";
import { Constants } from "@constants/OperacionEnergia";
import { useAuthentication } from "@/.shared/services/auth/authentication";
import type { ExtendedUserInfo } from "@/.shared/services/auth/authentication/extended-user-info";
import { PermissionsApp } from "@/.shared/services/auth/authorization/authorization-service-impl";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import { computed, onMounted, ref } from "vue";

const autho = useAuthorization();
const api = useApi();
const auth = useAuthentication();
const mostrarBusquedaContactoLead = ref(false);

const esInmobiliario = computed(() => {
  return autho.hasPermission(PermissionsApp.EditSameRealStateAgencyInmueble) || 
         autho.hasPermission(PermissionsApp.EditSameRealStateCompanyInmueble);
});

onMounted(async () => {
  const idEmpresa = (auth.userInfo as ExtendedUserInfo | null)?.idEmpresaAgentes;
  if (!idEmpresa) {
    return;
  }
  const empresas = await api.callStandardApi("getEmpresasServiciosOperables", { showLoading: false }, idEmpresa, [TipoEmpresaServiciosEnum.Energia]);
  mostrarBusquedaContactoLead.value = empresas.some(
    (e) => e.Id === Constants.EmpresaServicios.ID_ENDESA_LEAD_WEB
  );
});

</script>
